import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminExportsListHeader from './ListHeader';
import AdminExportsListItem from './ListItem';

class AdminExportsList extends PureComponent {
  render() {
    const {
      exports,
      handleDownload,
    } = this.props;

    return (
      <div className="table-wrapper">
        <Table className="exports-list" responsive>
          <thead>
            <AdminExportsListHeader
              {...this.props}
            />
          </thead>
          <tbody>
            {exports.map(ex => (
              <AdminExportsListItem
                key={ex.uuid}
                exportItem={ex}
                handleDownload={handleDownload}
              />
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

AdminExportsList.propTypes = {
  exports: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleDownload: PropTypes.func.isRequired,
};

export default AdminExportsList;
